<template>
  <iColumn
    width="fill"
    height="fill"
    gap="none"
    wrap="nowrap"
    :min-height="0"
    data-test="call-side-panel"
    :data-panel="panel"
  >
    <iCallPanel
      :title="title"
      :close-label="`Close ${title.toLowerCase()}`"
      :close-test-id="closeTestId"
      :content-hidden="contentHidden"
      elevation="flat"
      @close="$emit('close')"
    >
      <slot />
    </iCallPanel>
  </iColumn>
</template>

<script>
export default {
  name: "CallSidePanel",
  props: {
    panel: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    closeTestId: {
      type: String,
      default: "call-side-panel-close",
    },
    contentHidden: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
};
</script>
